import React, {  } from 'react';
import DOMPurify from 'dompurify';
import _ from 'lodash';

export const SummaryRow = ({fieldName, formData, formFields, className = null, dataOverride = null, labelOverride = null, visible = true}) => {

  if(!visible) {
    return (null);
  }

  const field = formFields.find((f) => f["@column"] == fieldName);
  const label = labelOverride ? labelOverride : field?.properties.fieldcaption ?? fieldName;
  const dataEntry = formData[fieldName];
  let data = (dataEntry ? dataEntry.value : null) ?? "-";

  if(dataOverride) {
    data = dataOverride(data, field);
  }

  const cleanHtmlString = DOMPurify.sanitize(data);

  return (
    <div className={`summary-item ${className}`}>
      <div className="summary-item__label">{label}</div>
      <span className="summary-item__value" dangerouslySetInnerHTML={{ __html: cleanHtmlString }}></span>
    </div>
  );
};